const features = [
  {
    icon: 'ri-time-line',
    title: 'Save Research Time',
    description: 'Centralize all your product research in one organized sheet, eliminating the need to juggle multiple browser tabs and bookmarks.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Track Product Details',
    description: 'Log product names, URLs, seller info, pricing, and variant details so you never lose track of what you have ordered.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Compare Prices Easily',
    description: 'Compare similar products from different sellers side by side to find the best value for your budget.',
  },
  {
    icon: 'ri-shopping-bag-3-line',
    title: 'Manage Orders Efficiently',
    description: 'Track order status from purchase through warehouse arrival to international shipping in one unified view.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Analyze Shipping Costs',
    description: 'Monitor weight, dimensions, and shipping fees to optimize your haul and reduce international delivery expenses.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Quality Check Tracking',
    description: 'Record warehouse inspection results and photos so you can make informed decisions before final shipment.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide mb-4">
            Why Use It
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 mb-3">
            Why You Need a BaseTao Spreadsheet
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            A structured spreadsheet approach transforms your shopping experience from chaotic to controlled.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${feature.icon} text-accent-600 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2 font-heading">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}